export const MODE = {
    VIEW: 1,
    EDIT: 2,
};
